import UserImage from "@/components/ui/forms/UserImage";
import {useLanguages} from "@/hooks/Languages";
import {setLanguage} from "@/redux/slices/commonSlices/settingsSlice";

import {useEffect} from "react";

import photoImage from "@images/cards/photo.svg";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {ChangePassPopup} from "@popups/requestPopups/ChangePassPopup";
import {ChangeRequestPopup} from "@popups/requestPopups/ChangeRequestPopup";
import {UploadFileProgressPopup} from "@popups/uploadPopups/UploadFileProgressPopup";
import {clearView, viewUser} from "@redux/slices/userSlices/viewSlice";
import {ControlButton} from "@ui/buttons/ControlButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {EditField} from "@ui/forms/EditField";
import {ViewField} from "@ui/forms/ViewField";
import {AvatarInitials} from "@ui/general/AvatarInitials/index";
import {Spinner} from "@ui/general/Spinner";
import Cookies from "js-cookie";
import "moment/locale/ru";
import moment from "moment/min/moment-with-locales";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";

import styles from "./styles.module.scss";

export const ProfilePage = () => {
  const {t, i18n} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {LANGUAGES} = useLanguages();

  const {id} = useParams();
  const {openPopup} = usePopup();
  const {current, status} = useSelector((state) => state.user.view);

  const handleOpenPopup = () => {
    openPopup(<ChangeRequestPopup />);
  };

  const handleClickImage = () => {
    openPopup(<UploadFileProgressPopup type={"image"} />);
  };

  const handleClickChangePass = () => {
    openPopup(<ChangePassPopup />);
  };

  const handleDeletePhoto = () => {
    console.log("remove photo");
  };

  const handleSelectLanguage = (option) => {
    dispatch(setLanguage(option.value));
    Cookies.set("language", option.value);
    i18n.changeLanguage(option.value);
    moment.locale(option.value);
  };

  const definitionLanguage = () => {
    if (current?.language) {
      return current?.language;
    } else {
      const languageValue = Cookies.get("language");
      const currentLanguage = LANGUAGES.find(
        (lang) => lang.value === languageValue,
      );

      return currentLanguage.name;
    }
  };

  useEffect(() => {
    dispatch(viewUser({id}));

    return () => {
      dispatch(clearView());
    };
  }, [dispatch, id]);

  return (
    <div className={styles.profileWrapper}>
      {status === "loading" ? (
        <Spinner
          width={80}
          height={80}
        />
      ) : (
        <div className={styles.profile}>
          <div className={styles.profileInfo}>
            {current?.cover ? (
              <UserImage
                onClickDelete={
                  current?.role !== "Admin" ? handleDeletePhoto : undefined
                }
                onClick={
                  current?.role !== "Admin" ? handleClickImage : undefined
                }
                photoImage={current?.role !== "Admin" ? photoImage : undefined}
                photoFile={current?.metadata}
                user={current}
              />
            ) : (
              <AvatarInitials
                name={current?.name}
                lastName={current?.lastname}
                size={160}
                fontSize={70}
              />
            )}
          </div>

          <div className={styles.content}>
            <ul>
              <ViewField
                label={t("input.last_name")}
                value={current?.lastname || "-"}
              />

              <ViewField
                label={t("input.email")}
                value={current?.email || "-"}
              />

              <ViewField
                label={t("input.password")}
                customContent={
                  <RootDesc>
                    <span style={{padding: "4rem 8rem"}}>
                      **********
                      {current?.role !== "Admin" && (
                        <i className={styles.profileEditPassword}>
                          <ControlButton
                            color={"var(--blue)"}
                            txt={t("button.edit")}
                            onClick={handleClickChangePass}
                          />
                        </i>
                      )}
                    </span>
                  </RootDesc>
                }
              />

              <ViewField
                label={t("input.role")}
                value={current?.role || "-"}
              />

              {current?.role !== "Admin" && (
                <>
                  <ViewField
                    label={t("input.product_line")}
                    value={current?.product_line || "-"}
                  />

                  <ViewField
                    label={t("input.country")}
                    value={current?.country || "-"}
                  />
                </>
              )}

              <EditField
                label={t("input.language")}
                type={"select"}
                width={200}
                height={150}
                activeOption={definitionLanguage()}
                options={LANGUAGES}
                onSelect={handleSelectLanguage}
              />
            </ul>

            <ControlButton
              color={"var(--blue)"}
              txt={
                current?.role !== "Admin"
                  ? t("button.change_req")
                  : t("button.edit")
              }
              onClick={
                current?.role !== "Admin"
                  ? handleOpenPopup
                  : () => navigate(`/admin-panel/users/edit/${id}`)
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};
